/**
 * 0xRRGGBB = #RRGGBB
 */
export type RGBColorNumber = number;

/**
 * '#RRGGBB'
 */
export type RGBColorString = string;

export function rgbNumberToString(
  num: RGBColorNumber,
  includeHash = true,
): RGBColorString {
  if (num > 0xffffff || num < 0) {
    throw new RangeError();
  }
  return `${includeHash ? '#' : ''}${`000000${num.toString(16)}`.substr(-6)}`;
}

export function rgbStringToNumber(rgbString: RGBColorString): RGBColorNumber {
  let result: RGBColorNumber;
  const rgbStringWithoutHash = rgbString.startsWith('#')
    ? rgbString.substr(1)
    : rgbString;
  switch (rgbStringWithoutHash.length) {
    case 6:
      result = Number.parseInt(rgbStringWithoutHash, 16);
      break;
    case 3: {
      const [r, g, b] = rgbStringWithoutHash;
      result = Number.parseInt(`${r}${r}${g}${g}${b}${b}`, 16);
      break;
    }
    default:
      result = Number.NaN;
  }
  if (Number.isNaN(result) || result < 0) {
    throw new Error('Invalid RGB string');
  }
  return result;
}
